// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.progress[data-v-ccf6547c] {\n  width: 100%;\n  margin-bottom: 2px;\n}\n.progress .progress-bar[data-v-ccf6547c] {\n  margin: 0;\n}\n.progress .progress-bar-inprogress[data-v-ccf6547c] {\n  background-color: #bbbdc0;\n}\n.progress .progress-bar-inprogress-arrow[data-v-ccf6547c] {\n  width: 0;\n  height: 0;\n  border-left: 10px solid #bbbdc0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  background: transparent;\n}\n", ""]);
// Exports
module.exports = exports;
